
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genres/[alias]",
      function () {
        return require("private-next-pages/genres/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genres/[alias]"])
      });
    }
  